module.exports = "<div class=all-warehouses-cell-inner> <div class=q-inline-block> All Warehouses </div> <a href=# class=\"base-btn v2-btn btn-down-arrow q-marg-left-md warehouse-down-btn\"> <i class=\"fa fa-angle-down\" aria-hidden=true></i> </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/inventory/lookup/html/allWarehouses.html
// module id = 1327
// module chunks = 1